import React, { useState } from 'react';

const LandingPage = () => {
  const [activeFeature, setActiveFeature] = useState(0);

  const featureImages = [
    'images/feature-1.png',
    'images/DocMedimg2.png',
    'images/feature-2.png'
  ];

  const testimonials = [
    {
      image: 'images/testimonial-1.png',
      username: '@sonya_k',
      text: 'Моя голова — это улей из тревожных мыслей, особенно по ночам. Открываю чат, просто пишу, что чувствую, и получаю ответ... не просто совет, а такие слова из Псалмов, от которых на душе становится тихо. Теперь каждый день перед сном я вываливаю накопившееся в чат. Помогает заснуть со светлыми мыслями.'
    },
    {
      image: 'images/testimonial-2.png',
      username: '@dark_matter_mind',
      text: 'Честно, я всегда считал Библию чем-то вроде музейного экспоната. Скучно и не про меня. Это приложение просто взорвало мой мозг. Оно показало, что проблемы с выгоранием, поиском себя и токсичными отношениями были у людей и тысячи лет назад. И главное — показало, как они находили выход. Неожиданно и очень мощно.'
    },
    {
      image: 'images/testimonial-4.png',
      username: '@a.smirnova',
      text: 'Ужасно поссорилась с родителями и не знала, как сделать первый шаг. Задала вопрос про гнев и прощение. Ответ был не про «просто прости», а про то, как это сделать. Притча о блудном сыне, объясненная простым языком, дала мне силы позвонить первой. Это сработало.'
    },
    {
      image: 'images/testimonial-3.png',
      username: '@mark_1990',
      text: 'Приложение показало мне места из Евангелия, которые прямо говорят к моей ситуации. Матфея 6:34 о тревоге — это будто написано про меня. Теперь перечитываю каждое утро. Стало легче дышать.'
    },
    {
      image: null,
      username: '@vera_search',
      text: 'Я искала ответы везде: в книгах по психологии, у коучей, в подкастах. А оказалось, что нужные слова были в Библии. Приложение помогло мне их найти и понять. Спасибо за то, что сделали Писание доступным.'
    }
  ];

  return (
    <div className="content-stretch flex flex-col items-start relative size-full" data-name="Landing page">
      {/* Header */}
      <div className="bg-white box-border content-stretch flex h-[65px] items-center px-[20px] md:px-8 lg:px-[150px] py-0 shrink-0 w-full lg:sticky lg:top-0 lg:z-50" data-name="Header">
        <div className="content-stretch flex gap-[12px] items-center relative shrink-0">
          <div className="border border-[#ac5906] border-solid relative rounded-[7px] shrink-0 size-[33px]">
            <img alt="Logo" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none rounded-[7px] size-full" src="images/logo.png" />
          </div>
          <div className="flex flex-col font-['Inter'] font-bold h-[33px] justify-center leading-[0] not-italic relative shrink-0 text-[#ac5906] text-[20px] whitespace-nowrap">
            <p className="leading-[24px]">.Точка опоры.</p>
          </div>
        </div>

        {/* Desktop Download Button */}
        <div className="hidden lg:flex content-stretch items-center relative shrink-0 ml-auto">
          <div className="bg-[#ac5906] box-border content-stretch flex gap-[7px] items-center justify-center px-[12px] py-[5px] relative rounded-[10px] shrink-0 w-[138.538px] cursor-pointer hover:bg-[#8a4905] transition-colors">
            <div className="h-[22.723px] relative shrink-0 w-[18.538px]">
              <img alt="Apple" className="block max-w-none size-full" src="images/apple-icon.svg" />
            </div>
            <div className="basis-0 content-stretch flex flex-col font-['Inter'] font-medium grow items-start leading-[0] min-h-px min-w-px not-italic relative shrink-0 text-white gap-[2px]">
              <div className="flex flex-col justify-center relative shrink-0 text-[9px] w-[43px]">
                <p className="leading-[9px]">скачать в</p>
              </div>
              <div className="flex flex-col justify-center relative shrink-0 text-[15.1px] w-[72px]">
                <p className="leading-[15px]">App Store</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="box-border content-stretch flex flex-col lg:flex-row gap-8 lg:gap-[50px] items-center px-[30px] md:px-8 lg:px-[150px] py-[30px] md:py-[80px] relative shrink-0 w-full">
        <div className="w-full lg:basis-0 content-stretch flex flex-col gap-[20px] lg:grow items-start min-h-px min-w-px relative shrink-0">
          <div className="content-stretch flex flex-col gap-[10px] items-start leading-[0] not-italic relative shrink-0 w-full">
            <div className="flex flex-col font-['Inter'] font-bold justify-center relative shrink-0 text-[#ac5906] text-[40px] md:text-[36px] lg:text-[46.4px] w-full">
              <p className="leading-[47px] lg:leading-[65px]">
                <span className="font-normal">Найдите свою</span>
                <span> Точку Опоры.</span>
              </p>
            </div>
            <div className="flex flex-col font-['Inter'] font-medium justify-center leading-[38px] lg:leading-[48px] relative shrink-0 text-[30px] md:text-[32px] lg:text-[40px] text-black w-full">
              <p className="mb-0">
                Тревоги XXI века.
                <br />
                Мудрость писаний.
              </p>
              <p>Современные ответы.</p>
            </div>
          </div>
          <div className="flex flex-col font-['Inter'] font-normal justify-center leading-[27px] lg:leading-[24px] min-w-full not-italic relative shrink-0 text-[20px] md:text-[15.2px] text-black w-[min-content]">
            <p className="block md:hidden">ИИ чат «Точка опоры» помогает вам увидеть, как вечные истины из священных писаний отвечают на ваши самые современные вопросы: о выгорании, отношениях, поиске себя и тревоге о будущем. Вы сможете найти ответы.</p>
            <p className="hidden md:block mb-0">Почему мудрость, записанная тысячи лет назад в Библии, так актуальна сегодня? Потому что технологии меняются, а человеческое сердце — нет. </p>
            <p className="hidden md:block">«Точка опоры» помогает вам увидеть, как вечные истины из священных писаний отвечают на ваши самые современные вопросы: о выгорании, отношениях, поиске себя и тревоге о будущем. Вы сможете найти ответы. Просто откройте чат с ИИ и все увидите.</p>
          </div>
          <div className="content-stretch flex items-center relative shrink-0 w-full md:w-auto">
            <div className="bg-[#ac5906] box-border flex gap-[7px] md:gap-[11px] h-[48px] md:h-[50px] items-center justify-center px-[12px] py-[5px] rounded-[10px] cursor-pointer hover:bg-[#8a4905] transition-colors w-full md:w-auto">
              <img alt="Apple" className="h-[26px] md:h-[33px] w-[22px] md:w-[27px]" src="images/apple-icon.svg" />
              <div className="flex flex-col font-['Inter'] font-medium gap-[3px] md:gap-[5px] text-white">
                <p className="text-[10px] md:text-[9px] leading-[10px] md:leading-[4px]">скачать в</p>
                <p className="text-[17px] md:text-[19px] leading-[26px] md:leading-[30px]">App Store</p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[350px] md:max-w-[500px] lg:w-[500px] h-auto relative shrink-0">
          <img alt="App Main Screen" className="w-full h-auto object-contain" src="images/app-composite.png" />
        </div>
      </div>

      {/* Main Features Section */}
      <div className="box-border content-stretch flex flex-col gap-[20px] md:gap-[70px] items-center px-[20px] md:px-8 lg:px-[150px] py-[80px] relative shrink-0 w-full">
        <div className="flex flex-col font-['Inter'] font-medium justify-center leading-[0] not-italic relative shrink-0 text-[28px] md:text-[36px] lg:text-[44.8px] text-black text-center w-full">
          <p className="leading-[40px]">От вопроса — к пониманию</p>
        </div>
        <div className="content-stretch flex flex-col lg:flex-row gap-8 lg:gap-[50px] items-center justify-center relative shrink-0 w-full">
          <div className="content-stretch flex flex-col items-center relative shrink-0 w-full lg:w-[475px]">
            <div className="w-full max-w-[475px] h-auto relative shrink-0">
              <img
                alt="Feature Screenshot"
                className="w-full h-auto object-contain"
                src={featureImages[activeFeature]}
              />
            </div>
            <div className="box-border content-stretch flex gap-[10px] items-start p-[10px] relative shrink-0">
              {[0, 1, 2].map((index) => (
                <div
                  key={index}
                  className={`rounded-full shrink-0 size-[12px] cursor-pointer ${
                    activeFeature === index ? 'bg-gray-800' : 'bg-gray-300'
                  }`}
                  onClick={() => setActiveFeature(index)}
                />
              ))}
            </div>
          </div>
          <div className="content-stretch flex flex-col gap-[40px] md:gap-[70px] items-center relative shrink-0 w-full lg:w-[544px]">
            <div
              className={`box-border content-stretch flex flex-col gap-[8px] items-start leading-[0] not-italic p-[20px] md:p-[26.05px] relative rounded-[16.8px] shrink-0 text-black w-full cursor-pointer transition-all ${
                activeFeature === 0 ? 'bg-[#fff6df] border-[1.05px] border-black border-solid' : 'bg-white border-[1.05px] border-black border-solid'
              }`}
              onClick={() => setActiveFeature(0)}
            >
              <div className="flex flex-col font-['Inter'] font-semibold justify-center relative shrink-0 text-[16px] md:text-[19.845px]">
                <p className="leading-[1.5] md:leading-[29.4px]">Ваш вопрос — начало пути</p>
              </div>
              <div className="flex flex-col font-['Inter'] font-normal justify-center min-w-full relative shrink-0 text-[14px] md:text-[15.96px]">
                <p className="leading-[1.6] md:leading-[25.2px]">Начните диалог так, как вам удобно. Сформулируйте то, что у вас на сердце — от личных переживаний до философских сомнений. Приложение поймет глубину вашего запроса и поможет раскрыть смысл сложных отрывков писаний.</p>
              </div>
            </div>
            <div
              className={`box-border content-stretch flex flex-col gap-[8px] items-start leading-[0] not-italic p-[20px] md:p-[26.05px] relative rounded-[16.8px] shrink-0 text-black w-full cursor-pointer transition-all ${
                activeFeature === 1 ? 'bg-[#fff6df] border-[1.05px] border-black border-solid' : 'bg-white border-[1.05px] border-black border-solid'
              }`}
              onClick={() => setActiveFeature(1)}
            >
              <div className="flex flex-col font-['Inter'] font-semibold justify-center relative shrink-0 text-[16px] md:text-[19.845px]">
                <p className="leading-[1.5] md:leading-[29.4px]">Ответы на все вопросы уже написаны</p>
              </div>
              <div className="flex flex-col font-['Inter'] font-normal justify-center min-w-full relative shrink-0 text-[14px] md:text-[15.96px]">
                <p className="leading-[1.6] md:leading-[25.2px]">Они есть в Писании. Наш ИИ-собеседник помогает вам раскрыть их смысл, находя нужные места из Библии для вашей конкретной ситуации.</p>
              </div>
            </div>
            <div
              className={`box-border content-stretch flex flex-col gap-[8px] items-start leading-[0] not-italic p-[20px] md:p-[26.05px] relative rounded-[16.8px] shrink-0 text-black w-full cursor-pointer transition-all ${
                activeFeature === 2 ? 'bg-[#fff6df] border-[1.05px] border-black border-solid' : 'bg-white border-[1.05px] border-black border-solid'
              }`}
              onClick={() => setActiveFeature(2)}
            >
              <div className="flex flex-col font-['Inter'] font-semibold justify-center relative shrink-0 text-[16px] md:text-[19.845px]">
                <p className="leading-[1.5] md:leading-[29.4px]">От мысли — к первоисточнику</p>
              </div>
              <div className="flex flex-col font-['Inter'] font-normal justify-center min-w-full relative shrink-0 text-[14px] md:text-[15.96px]">
                <p className="leading-[1.6] md:leading-[25.2px]">Каждая мысль в ответе неразрывно связана с первоисточником. Переходите к полному тексту цитаты в один клик, чтобы самостоятельно изучить контекст и убедиться в точности толкования.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="box-border content-stretch flex flex-col gap-[20px] md:gap-[70px] items-center px-[20px] md:px-8 lg:px-[150px] py-[80px] relative shrink-0 w-full">
        <div className="flex flex-col font-['Inter'] font-medium justify-center leading-[0] not-italic relative shrink-0 text-[28px] md:text-[36px] lg:text-[44.8px] text-black text-center w-full max-w-[724px]">
          <p className="leading-[1.6] lg:leading-[72px]">Ваша Точка Опоры в мире хаоса</p>
        </div>
        <div className="content-stretch flex flex-col md:flex-row gap-[50px] md:gap-[32px] lg:gap-[50px] items-stretch relative shrink-0 w-full">
          <div className="w-full md:flex-1 bg-white relative rounded-[20px] md:rounded-[30px] shadow-[0px_1px_20px_1px_rgba(228,229,233,0.5)]">
            <div className="box-border content-stretch flex flex-col gap-[12px] md:gap-[16px] items-start p-[24px] md:p-[32px] relative">
              <div className="h-[50px] md:h-[63px] relative shrink-0 w-[50px] md:w-[64px]">
                <img alt="Confidentiality Icon" className="block max-w-none size-full" src="images/icon-confidentiality.svg" />
              </div>
              <div className="flex flex-col font-['Inter'] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[16px] md:text-[18.6px] text-black">
                <p className="leading-[24px] md:leading-[28px]">Полная конфиденциальность</p>
              </div>
              <div className="flex flex-col font-['Inter'] font-normal justify-center leading-[0] min-w-full not-italic relative shrink-0 text-[13px] md:text-[13.5px] text-gray-700">
                <p className="leading-[18px] md:leading-[20px]">Ваши диалоги конфиденциальны. Это безопасное пространство для самых сокровенных вопросов, свободных от осуждения и страха.</p>
              </div>
            </div>
          </div>
          <div className="w-full md:flex-1 bg-white relative rounded-[20px] md:rounded-[30px] shadow-[0px_1px_20px_1px_rgba(228,229,233,0.5)]">
            <div className="box-border content-stretch flex flex-col gap-[12px] md:gap-[16px] items-start p-[24px] md:p-[32px] relative">
              <div className="h-[50px] md:h-[63px] relative shrink-0 w-[50px] md:w-[64px]">
                <img alt="Book Icon" className="block max-w-none size-full" src="images/icon-book.svg" />
              </div>
              <div className="flex flex-col font-['Inter'] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[16px] md:text-[18.6px] text-black">
                <p className="leading-[24px] md:leading-[28px]">Глубокое понимание писаний</p>
              </div>
              <div className="flex flex-col font-['Inter'] font-normal justify-center leading-[0] min-w-full not-italic relative shrink-0 text-[13px] md:text-[13.5px] text-gray-700">
                <p className="leading-[18px] md:leading-[20px]">Вместо мимолетных советов из ленты соцсетей — ответы, основанные на самых влиятельных книгах в истории человечества. Доберитесь до сути, а не до чужих интерпретаций.</p>
              </div>
            </div>
          </div>
          <div className="w-full md:flex-1 bg-white relative rounded-[20px] md:rounded-[30px] shadow-[0px_1px_20px_1px_rgba(228,229,233,0.5)]">
            <div className="box-border content-stretch flex flex-col gap-[12px] md:gap-[16px] items-start p-[24px] md:p-[32px] relative">
              <div className="h-[50px] md:h-[63px] relative shrink-0 w-[50px] md:w-[64px]">
                <img alt="24/7 Icon" className="block max-w-none size-full" src="images/icon-24-7.svg" />
              </div>
              <div className="flex flex-col font-['Inter'] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[16px] md:text-[18.6px] text-black">
                <p className="leading-[24px] md:leading-[28px]">Поддержка в любой момент</p>
              </div>
              <div className="flex flex-col font-['Inter'] font-normal justify-center leading-[0] min-w-full not-italic relative shrink-0 text-[13px] md:text-[13.5px] text-gray-700">
                <p className="leading-[18px] md:leading-[20px]">Духовный поиск не знает расписания. Получайте пищу для размышлений из Писания 24/7, именно тогда, когда это необходимо больше всего.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="box-border content-stretch flex flex-col gap-[20px] md:gap-[70px] items-center px-[20px] md:px-8 lg:px-[150px] py-[80px] relative shrink-0 w-full">
        <div className="flex flex-col font-['Inter'] font-medium justify-center leading-[0] not-italic relative shrink-0 text-[28px] md:text-[36px] lg:text-[44.8px] text-black text-center w-full max-w-[724px]">
          <p className="leading-[1.6] lg:leading-[72px]">Что о нас говорят</p>
        </div>
        <div className="content-center flex flex-wrap gap-[50px] md:gap-[32px] lg:gap-[50px] items-center justify-center relative shrink-0 w-full">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-[#fff5eb] border border-gray-700 border-solid box-border content-stretch flex flex-col gap-[16px] items-start p-[24px] md:p-[34px] relative rounded-[16px] shrink-0 w-full sm:w-[320px] hover:shadow-lg transition-shadow"
            >
              <div className="relative shrink-0 w-full">
                <div className="box-border content-stretch flex gap-[16px] items-center relative w-full">
                  {testimonial.image ? (
                    <div className="relative rounded-full shrink-0 size-[42px]">
                      <img alt={testimonial.username} className="absolute inset-0 max-w-none object-50%-50% object-contain pointer-events-none rounded-full size-full" src={testimonial.image} />
                    </div>
                  ) : (
                    <div className="bg-gray-300 relative rounded-full shrink-0 size-[42px] flex items-center justify-center">
                      <p className="font-['Inter'] font-bold text-[19.5px] text-gray-500">D</p>
                    </div>
                  )}
                  <div className="basis-0 flex flex-col font-['Inter'] font-medium grow justify-center leading-[0] min-h-px min-w-px not-italic relative shrink-0 text-[#2b2b2b] text-[18.9px]">
                    <p className="leading-[30px]">{testimonial.username}</p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col font-['Inter'] font-normal justify-center leading-[0] not-italic relative shrink-0 text-[#2b2b2b] text-[13.5px] w-full">
                <p className="leading-[20px]">"{testimonial.text}"</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="box-border content-stretch flex flex-col md:flex-row gap-[32px] items-start px-[20px] md:px-8 lg:px-[150px] py-12 md:py-16 lg:py-[80px] relative shrink-0 w-full">
        <div className="w-full md:basis-0 md:grow min-h-px min-w-px relative shrink-0">
          <div className="box-border content-stretch flex flex-col gap-[22px] items-start relative w-full">
            <div className="content-stretch flex gap-[12px] items-center relative shrink-0">
              <div className="border border-[#ac5906] border-solid relative rounded-[7px] shrink-0 size-[33px]">
                <img alt="Logo" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none rounded-[7px] size-full" src="images/logo.png" />
              </div>
              <div className="flex flex-col font-['Inter'] font-bold h-[33px] justify-center leading-[0] not-italic relative shrink-0 text-[#ac5906] text-[20px]">
                <p className="leading-[24px]">.Точка опоры.</p>
              </div>
            </div>
            <div className="flex flex-col font-['Inter'] font-normal justify-center leading-[0] min-w-full not-italic relative shrink-0 text-[13.5px] text-gray-600">
              <p className="leading-[20px]">Скачивайте Точка опоры</p>
            </div>
            <div className="content-stretch flex items-center relative shrink-0">
              <div className="bg-[#ac5906] box-border content-stretch flex gap-[7px] items-center justify-center px-[12px] py-[5px] relative rounded-[10px] shrink-0 w-[138.538px] cursor-pointer hover:bg-[#8a4905] transition-colors">
                <img alt="Apple" className="h-[22.723px] w-[18.538px]" src="images/apple-icon.svg" />
                <div className="flex flex-col font-['Inter'] font-medium text-white">
                  <p className="text-[9px] leading-[4px]">скачать в</p>
                  <p className="text-[15.1px] leading-[24px]">App Store</p>
                </div>
              </div>
            </div>
            <div className="flex flex-col font-['Inter'] font-normal justify-center leading-[0] not-italic relative shrink-0 text-[13.5px] text-gray-500">
              <p className="leading-[20px]">© Copyright 2025, All rights reserved</p>
            </div>
          </div>
        </div>
        <div className="w-full md:basis-0 md:grow min-h-px min-w-px relative shrink-0">
          <div className="box-border content-stretch flex flex-col gap-[16px] items-start leading-[0] not-italic relative w-full">
            <div className="flex flex-col font-['Inter'] font-semibold justify-center relative shrink-0 text-[14.6px] text-black">
              <p className="leading-[24px]">Правовая информация</p>
            </div>
            <a href="/privacy-policy.html" className="flex flex-col font-['Inter'] font-normal justify-center relative shrink-0 text-[13.5px] text-gray-600 hover:text-[#ac5906] transition-colors">
              <p className="leading-[20px]">Политика конфиденциальности</p>
            </a>
            <a href="/terms-of-service.html" className="flex flex-col font-['Inter'] font-normal justify-center relative shrink-0 text-[13.5px] text-gray-600 hover:text-[#ac5906] transition-colors">
              <p className="leading-[20px]">Правила использования сервиса</p>
            </a>
            <a href="/support.html" className="flex flex-col font-['Inter'] font-normal justify-center relative shrink-0 text-[13.5px] text-gray-600 hover:text-[#ac5906] transition-colors">
              <p className="leading-[20px]">Поддержка</p>
            </a>
          </div>
        </div>
        <div className="w-full md:basis-0 md:grow min-h-px min-w-px relative shrink-0">
          <div className="box-border content-stretch flex flex-col gap-[10px] items-start leading-[0] not-italic relative w-full">
            <div className="flex flex-col font-['Inter'] font-semibold justify-center relative shrink-0 text-[14.6px] text-black">
              <p className="leading-[24px]">Контакты</p>
            </div>
            <div className="flex flex-col font-['Inter'] font-normal justify-center relative shrink-0 text-[13.5px] text-gray-600">
              <p className="leading-[20px]">@genie_genie_genie</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
